import { rgbToHex, spaceToSpace } from '.';

export const hsluvToHex = (hsluv: number[]): string =>
  rgbToHex(spaceToSpace(hsluv, 'hsluv', 'rgb'));
